@if (isButtonVisible) {
<button
  class="scroll-to-top"
  [class.visible]="isButtonVisible"
  (click)="scrollToTop($event)"
  [attr.aria-label]="'Scroll to Top' | globalTranslate"
  type="button"
>
  <svg
    class="progress-ring"
    width="70"
    height="70"
    aria-hidden="true"
    role="presentation"
  >
    <circle
      cx="35"
      cy="35"
      r="30"
      stroke-dasharray="188"
      [attr.stroke-dashoffset]="188 - (188 * scrollProgress) / 100"
    ></circle>
  </svg>
  <mat-icon aria-hidden="true" role="presentation">arrow_upward_alt</mat-icon>
</button>
}